import type { Channel } from 'stream-chat';
import { StreamMessage } from 'stream-chat-react';

export const sendMessageRequest = async (
    channel: Channel,
    messageObj: StreamMessage,
    updateMessage: (message: StreamMessage) => void
) => {
    const messageData = { id: messageObj.id, text: messageObj.text };
    try {
        const messageResponse = await channel.sendMessage(messageData);
        if (messageResponse?.message) {
            updateMessage({ ...messageResponse.message, status: 'received' });
        }
        return true;
    } catch (error) {
        const errorCode = getErrorStatusCode(JSON.stringify(error));
        updateMessage({ ...messageObj, errorStatusCode: errorCode, status: 'failed' });
        return false;
    }
};

const getErrorStatusCode = (error: string) => {
    const parsedError = error ? JSON.parse(error) : {};
    return (parsedError?.status as number) || undefined;
};
